"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultJsonSerializer = void 0;
exports.defaultJsonSerializer = JSON;
//# sourceMappingURL=defaultJsonSerializer.js.map